import { getCheckoutState } from 'merchant-api/checkout';
import { CheckoutData } from 'merchant-api/types';
import { useEffect } from 'react';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { checkout } from '..';

interface ContractProps {
  isLoadingContract: boolean;
  isErrorContract: boolean | null;
  checkoutData: CheckoutData | undefined;
  openContractPdf: () => void;
  mutation: UseMutationResult<string, Error, void>;
}

export function getContract(): ContractProps {
  const apiUrl = import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL'];
  const { isLoadingCheckoutState, isErrorCheckoutState, checkoutData } =
    getCheckoutState();

  const mutation = useMutation({
    mutationFn: async () => {
      return checkout
        .get(`/v1/contracts/${checkoutData?.checkoutUuid}`, {
          responseType: 'text',
        })
        .then((res) => res.data);
    },
    mutationKey: ['getContract', checkoutData?.checkoutUuid],
  });

  const openNewWindow = () =>
    window.open(
      `${apiUrl}/v1/contracts/${checkoutData?.checkoutUuid}`,
      '_blank',
      'noopener,noreferrer',
    );

  const openContractPdf = () =>
    mutation.data ? openNewWindow() : mutation.mutate();

  useEffect(() => {
    mutation.data && openNewWindow();
  }, [mutation.data]);

  return {
    isLoadingContract: mutation.isPending || isLoadingCheckoutState,
    isErrorContract: mutation.error || isErrorCheckoutState,
    checkoutData: checkoutData,
    openContractPdf,
    mutation,
  };
}
